import { createFileRoute } from "@tanstack/react-router";
import { TextCreateFlow } from "@/components/text-banking/TextCreateFlow";

export const Route = createFileRoute("/_app/_/contacts/text-banking/new")({
	component: ContactsTextBankingNewPage,
});

function ContactsTextBankingNewPage() {
	return (
		<div className="p-6">
			<TextCreateFlow backTo="/contacts?tab=text-banking" />
		</div>
	);
}
